import React, { Component } from 'react';
import { tsLiveServerENV } from '../ENV';

const secondInMs = 1000;
const minuteInMs = 60 * secondInMs;
const expoBackoffMin = 1000;
const expoBackoffMax = minuteInMs * 15;

class News extends Component {
	constructor(props) {
		super(props);

		let reqRate = minuteInMs * 60;
		if (this.props.request_rate && typeof this.props.request_rate === 'number') {
			reqRate = this.props.request_rate * secondInMs;
		}

		this.state = {
			animationState:	 	'fadeIn',
			containerWidth:  	0,
			containerHeight: 	0,
			currentItem:     	0,
			css:            	props.CSSModules[props.condor_render_name],
			data:           	[],
			title:           	'Headline News',
			nextItem:			1,
			prevItem:   		this.props.limit - 1,
			stories:    		[],
			successfulRequest: 	false,
			network:         	1,
			offlineMins:    	0,
			request_rate:    	reqRate,
			request_timer:   	false,
			request_backoff: 	expoBackoffMin,
			refresh: 			'',
			timer: null,
			animationRetryCount: 0  // Track retry attempts for animation initialization
		};

		this.initializeAnimation = this.initializeAnimation.bind(this);
		this.startAnimationCycle = this.startAnimationCycle.bind(this);
		this.stopAnimationCycle  = this.stopAnimationCycle.bind(this);
		this.setAnimationType    = this.setAnimationType.bind(this);

		this.cycleStories       = this.cycleStories.bind(this);
		this.fadeStories        = this.fadeStories.bind(this);
		this.rollStoriesUp      = this.rollStoriesUp.bind(this);
		this.slideStoriesLeft   = this.slideStoriesLeft.bind(this);

		this.getData            = this.getData.bind(this);
		this.createStories      = this.createStories.bind(this);
	}

	componentDidMount() {
		setTimeout(() => this.initializeAnimation(), 1500);
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.request_rate !== this.props.request_rate &&
			typeof this.props.request_rate === 'number'
		) {
			let request_rate = this.props.request_rate * secondInMs;
			this.setState({ request_rate });
		}
	}

	componentWillUnmount() {
		console.log('News unmounted');
		this.stopAnimationCycle();
		clearTimeout(this.state.request_timer); 
	}

	initializeAnimation() {
		// React 19 fix: Force layout flush with double RAF before reading DOM dimensions
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				const container = document.getElementById(`news_${this.props.component_name}`);
				if (container) {
					this.setState({
						containerWidth:  container.offsetWidth,
						containerHeight: container.offsetHeight
					}, () => {
						// Call getData after dimensions are set in state
						this.getData();
					});
				} else {
					// If container not found, still call getData
					this.getData();
				}
			});
		});
	}

	getData() {
		const target = `${tsLiveServerENV}/news`;

		const getFileSuccess = (jsonData) => {
			if (jsonData.fail !== undefined) {
				getFileFail(new Error('Cannot handle this format of data'));
				return;
			}
			let timer = setTimeout(this.getData, this.state.request_rate);

			this.setState({
				data:              jsonData,
				request_backoff:   expoBackoffMin,
				request_timer:     timer,
				successfulRequest: true
			}, () => {
				// React 19 fix: Call createStories in callback to ensure data is in state
				this.createStories();
			});
		};

		const getFileFail = (error) => {
			console.error(error);

			// Exponential backoff
			let currentBackoff = this.state.request_backoff;
			let nextBackoff = currentBackoff * 2;
			if (nextBackoff > expoBackoffMax) {
				nextBackoff = expoBackoffMax;
			}

			let timer = setTimeout(this.getData, currentBackoff);
			this.setState({
				request_backoff: nextBackoff,
				request_timer:   timer
			});
		};

		try {
			fetch(target)
				.then((response) => response.json())
				.then((jsonData) => getFileSuccess(jsonData))
				.catch((err) => getFileFail(err));
		} catch (err) {
			getFileFail(err);
		}
	}

	createStories() {
		const { css, data, containerWidth, title } = this.state;

		let titleClass = css.titleOff;
		if (title !== '') {
			titleClass = css.titleOn;
		}

		const newsItemStyles = {
			width: `${containerWidth}px`
		};

		let keys = Object.keys(data);
		let allStories = [];

		// First pass: collect all raw story data
		for (let i = 0; i < keys.length; i++) {
			let key = keys[i];
			let value = data[key];
			if (value && Array.isArray(value)) {
				value.forEach((item) => {
					allStories.push({ key, item });
				});
			}
		}

		// Second pass: create story elements with correct IDs based on global index
		let storiesArr = allStories.map((storyData, globalIdx) => {
			let storyId = null;
			if (globalIdx === 0) {
				storyId = 'firstStory';
			} else if (globalIdx === Math.min(allStories.length - 1, this.props.limit - 1)) {
				storyId = 'lastStory';
			}

			// React 19 fix: key must be passed directly, not in spread props
			const storyKey = `${this.props.id}_${this.props.component_name}_${storyData.key}_${globalIdx}`;

			// Build props conditionally - only include id if it's not null
			const divProps = {
				'data-selector': 'news-item',
				className: `news_item ${css.newsItem} ${titleClass}`,
				style: newsItemStyles
			};

			if (storyId) {
				divProps.id = storyId;
			}

			return (
				<div key={storyKey} {...divProps}>
					<div className={`${css.headline} newsHeadline`}>{storyData.item.title}</div>
					<div className={`${css.description} newsDescription`}>
						<p>{storyData.item.description}</p>
					</div>
				</div>
			);
		});

		this.setState({ stories: storiesArr }, () => {
			// React 19 fix: Ensure DOM is updated before starting animation cycle
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					this.startAnimationCycle();
				});
			});
		});
	}

	/** Decide which function to call each interval based on animation_type. */
	setAnimationType() {
		switch (this.props.animation_type) {
			case 1: // "Snap" / "Cycle"
				return this.cycleStories;
			case 2: // Fade in/out
				return this.fadeStories;
			case 3: // Roll up
				return this.rollStoriesUp;
			case 4: // Slide left
				return this.slideStoriesLeft;
			default:
				return this.logError;
		}
	}

	startAnimationCycle() {
		if (!this.props.animation_type) return;

		// React 19 fix: For animation types 3 and 4, verify required DOM elements exist
		if (this.props.animation_type === 3 || this.props.animation_type === 4) {
			const container = document.getElementById(`container_${this.props.component_name}`);
			const firstStory = document.getElementById('firstStory');
			const lastStory = document.getElementById('lastStory');

			if (!container || !firstStory || !lastStory) {
				// Prevent infinite retry loop by defining explicit timeout duration and interval
				const RETRY_INTERVAL_MS = 100;
				const MAX_RETRY_DURATION_MS = 5000;
				const MAX_RETRIES = MAX_RETRY_DURATION_MS / RETRY_INTERVAL_MS;

				if (this.state.animationRetryCount >= MAX_RETRIES) {
					const missingElements = [];
				if (!container) missingElements.push('container');
				if (!firstStory) missingElements.push('firstStory');
				if (!lastStory) missingElements.push('lastStory');
				console.error(`News: Animation elements not found after ${MAX_RETRIES} retries (${MAX_RETRY_DURATION_MS}ms). Missing: ${missingElements.join(', ')}`);
					return;
				}

				// Increment retry counter and retry
				this.setState(prevState => ({
					animationRetryCount: prevState.animationRetryCount + 1
				}));
				setTimeout(() => this.startAnimationCycle(), RETRY_INTERVAL_MS);
				return;
			}

			// Reset retry counter on success
			if (this.state.animationRetryCount > 0) {
				this.setState({ animationRetryCount: 0 });
			}
		}

		let animate = this.setAnimationType();

		if (this.props.animation_type === 2) {
			this.setState({ animationState: 'fadeIn' });
		}

		const intervalMs = (this.props.animation_interval || 10) * 1000;
		this.stopAnimationCycle(); // ensure we don't double-interval
		this.timer = setInterval(() => {
			animate();
		}, intervalMs);
	}

	stopAnimationCycle() {
		clearInterval(this.timer);
	}

	fadeStories() {
		if (this.state.network === 1 || (this.state.network === 0 && this.state.offlineMins <= 1440)) {
			this.setState({ animationState: 'fadeOut' });
			setTimeout(() => {
				this.cycleStories();
				this.setState({ animationState: 'fadeIn' });
			}, 500);
		}
	}

	slideStoriesLeft() {
		if (!document.getElementById(`container_${this.props.component_name}`)) return;
		if (this.state.network === 1 || (this.state.network === 0 && this.state.offlineMins <= 1440)) {
			document.getElementById(`container_${this.props.component_name}`).scrollBy({
				left: this.state.containerWidth,
				behavior: 'smooth'
			});
			this.swapStories();
		}
	}

	rollStoriesUp() {
		if (!document.getElementById(`container_${this.props.component_name}`)) return;
		if (this.state.network === 1 || (this.state.network === 0 && this.state.offlineMins <= 1440)) {
			document.getElementById(`container_${this.props.component_name}`).scrollBy({
				top: this.state.containerHeight,
				behavior: 'smooth'
			});
			this.swapStories();
		}
	}

	logError() {
		console.error('News animation_type is invalid or undefined.');
	}

	swapStories() {
		const container = document.getElementById(`container_${this.props.component_name}`);
		const firstStory = document.getElementById('firstStory');
		const lastStory  = document.getElementById('lastStory');

		if (!container || !firstStory || !lastStory) {
			console.error('News: missing container or story elements');
			return;
		}

		setTimeout(() => {
			lastStory.after(firstStory);
			lastStory.removeAttribute('id');
			firstStory.setAttribute('id', 'lastStory');

			let items = document.querySelectorAll('div[data-selector="news-item"]');
			container.scrollTo(0, 0);

			if (items.length > 0) {
				items[0].setAttribute('id', 'firstStory');
			}
		}, 500);
	}

	cycleStories() {
		if (this.state.network === 1 || (this.state.network === 0 && this.state.offlineMins <= 1440)) {
			this.setState((prevState) => {
				let newCurrent = prevState.currentItem + 1;
				if (newCurrent > this.props.limit - 1) {
					newCurrent = 0;
				}
				let newPrev = newCurrent - 1;
				let newNext = newCurrent + 1;

				if (newPrev < 0) newPrev = this.props.limit - 1;
				if (newNext > this.props.limit - 1) newNext = 0;

				return {
					currentItem: newCurrent,
					prevItem:    newPrev,
					nextItem:    newNext
				};
			});
		}
	}

	render() {
		const { css, containerWidth, animationState, stories, currentItem } = this.state;

		// Custom classes
		let customClasses = '';
		if (Array.isArray(this.props.custom_classes)) {
			this.props.custom_classes.forEach((c) => {
				if ((/^([a-z_]|-[a-z_-])[a-z\d_-]*$/i).test(c)) {
					customClasses += ` ${c}`;
				}
			});
		}

		// Modifier classes
		let modifierClasses = '';
		if (Array.isArray(this.props.modifier_classes)) {
			this.props.modifier_classes.forEach((m) => {
				if ((/^([a-z_]|-[a-z_-])[a-z\d_-]*$/i).test(m)) {
					modifierClasses += ` ${m}`;
				}
			});
		}

		// Optional title
		let titleDiv = null;
		if (this.state.title !== '') {
			titleDiv = <div className={css.title}>{this.state.title}</div>;
		}

		const limitedStories = stories.slice(0, this.props.limit);

		const newsItemStyles = {
			width: `${containerWidth}px`
		};

		if (this.props.animation_type === 1) {
			// SNAP ANIMATION
			return (
				<div
					id={`news_${this.props.component_name}`}
					className={`news_wrapper ${css.news} ${modifierClasses} ${customClasses}`}
				>
					{titleDiv}
					<div
						id={`container_${this.props.component_name}`}
						className={`news_container ${css.container} ${css.snapContainer}`}
					>
						<div className={`news_item ${css.currentItem}`} style={newsItemStyles}>
							{limitedStories[currentItem]}
						</div>
					</div>
				</div>
			);
		}

		if (this.props.animation_type === 2) {
			// FADE ANIMATION
			return (
				<div
					id={`news_${this.props.component_name}`}
					className={`news_wrapper ${css.news} ${modifierClasses} ${customClasses}`}
				>
					{titleDiv}
					<div
						id={`container_${this.props.component_name}`}
						className={`news_container ${css.container} ${css.fadeContainer} ${css[animationState]}`}
					>
						<div className={`news_item ${css.currentItem}`} style={newsItemStyles}>
							{limitedStories[currentItem]}
						</div>
					</div>
				</div>
			);
		}

		if (this.props.animation_type === 3) {
			// ROLL UP
			return (
				<div
					id={`news_${this.props.component_name}`}
					className={`news_wrapper ${css.news} ${modifierClasses} ${customClasses}`}
				>
					{titleDiv}
					<div
						id={`container_${this.props.component_name}`}
						className={`news_wrapper ${css.container} ${css.rollContainer}`}
					>
						{limitedStories}
					</div>
				</div>
			);
		}

		if (this.props.animation_type === 4) {
			// SLIDE LEFT
			return (
				<div
					id={`news_${this.props.component_name}`}
					className={`news_wrapper ${css.news} ${modifierClasses} ${customClasses}`}
				>
					{titleDiv}
					<div
						id={`container_${this.props.component_name}`}
						className={`news_container ${css.container} ${css.slideContainer}`}
					>
						{limitedStories}
					</div>
				</div>
			);
		}

		// Fallback (no/invalid animation_type)
		return (
			<div
				id={`news_${this.props.component_name}`}
				className={`news_wrapper ${css.news} ${modifierClasses} ${customClasses}`}
			>
				<div className={css.container}>
					{titleDiv}
					<div className={`news_container ${css.currentItem}`} style={newsItemStyles}>
						{limitedStories[currentItem]}
					</div>
				</div>
			</div>
		);
	}
}

export default News;
